module.exports = __webpack_public_path__ + "static/media/Baslik.8b92330f.png";